import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import {
  type ResponseHeader,
  ResponseHeaderSchema,
} from '../responseHeader'
import {
  type LookupSiteResponsePayload,
  LookupSiteResponsePayloadSchema,
} from './lookupSiteResponsePayload'

export type LookupSiteResponse = {
  header: ResponseHeader
  payload?: LookupSiteResponsePayload
}

export const LookupSiteResponseSchema: CborSchema<LookupSiteResponse> =
  defineCborSchema<LookupSiteResponse>({
    header: CborField({ key: 0, type: ResponseHeaderSchema }),
    payload: CborField({ key: 1, required: false, type: LookupSiteResponsePayloadSchema }),
  })
